import { useState } from "react";

const useAttachments = () => {
  const [attachments, setAttachments] = useState([]);
  const [attachmentError, setAttachmentError] = useState(null);

  const handleAttachmentAdded = (file, imagePreviewUrl, error) => {
    if (error) {
      setAttachmentError(error.message);
      return;
    }
    setAttachments(currentAttachments => [...currentAttachments, { file, imagePreviewUrl }]);
    setAttachmentError(null);
  };

  const handleAttachmentRemoved = filename => {
    setAttachments(currentAttachments => currentAttachments.filter(value => value.file.name !== filename));
  };

  return { attachments, attachmentError, handleAttachmentAdded, handleAttachmentRemoved };
};

export default useAttachments;
